import { TableHeadItemRecurse } from '../../../components/TableHead';
import { ReportGeneratorListItemNormalized } from '../../../store/reportGenerator/types';

export const reportGeneratorListLayout = {
  mobileMaxHeight: 600,
  desktopMaxHeight: 380,
} as const;

export const reportGeneratorTableFrameInset = 'inline.quarck' as const;
export const reportGeneratorTableListPanelPadding = 'inset.sm' as const;
export const reportGeneratorTableHorizontalPadding = 'inline.xxxs' as const;

export const reportGeneratorTableHead: TableHeadItemRecurse<ReportGeneratorListItemNormalized>[] = [
  { title: 'Tipo do Relatório', orderValue: 'documentType', flex: 2.4 },
  { title: 'Solicitado em', orderValue: 'createdAt', flex: 1 },
  { title: 'Período selecionado', orderValue: 'reportingPeriod', flex: 1.6 },
  { title: 'Status', orderValue: 'REPORTINGSTATUS.STATUSID' as any, flex: 1 },
  { title: 'Ações', flex: 0.4 },
];

export const getReportGeneratorOrderByOptions = () =>
  reportGeneratorTableHead
    .filter(({ orderValue }) => !!orderValue)
    .map(({ orderValue, title }) => ({ label: title, value: orderValue as string }));

export const getReportGeneratorTableColumnFlex = (index: number) =>
  reportGeneratorTableHead[index]?.flex || 1;
